import PhoenixDocCard from 'components/base/PhoenixDocCard';
import DocPageHeader from 'components/docs/DocPageHeader';
import DocPagesLayout from 'layouts/DocPagesLayout';
import { Col, Row } from 'react-bootstrap';
import campaign from 'assets/img/spot-illustrations/campaign.png';
import CampaignList from 'pages/servicecampaignmanagement/HVABXPCampaignList';
import BXPGreetingList from 'pages/servicecampaignmanagement/BXPGreetingList';
import BXPTimeConditionList from 'pages/servicecampaignmanagement/BXPTimeConditionList';
import BXPMediaResourceGroupList from 'pages/servicecampaignmanagement/BXPMediaResourceGroupList';
import BXPOutboundRuleList from 'pages/servicecampaignmanagement/BXPOutboundRuleList';
import BXPCallingListList from 'pages/servicecampaignmanagement/BXPCallingListList';
import BXPTreatmentList from 'pages/servicecampaignmanagement/BXPTreatmentList';

const CampaignManagement = () => {
  return (
    <div>
      <DocPageHeader title="Campaign Management" />
      <DocPagesLayout>
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Campaigns"
            noPreview
            className="pb-3 pt-3"
          >
            <Row>
              <Col className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="mb-0">
                    Campaigns are specific tasks carried out by Humanize Virtual
                    Agents (HVAs) designed to achieve particular objectives,
                    such as gathering leads, promoting services, or engaging
                    customers. These campaigns often focus on direct
                    interactions through phone conversations, to convey
                    information or negotiate terms.
                    <br />
                    <br />
                    Each campaign is meticulously crafted to ensure the
                    messaging is clear, concise, and tailored to the specific
                    audience, maximizing the chances of achieving the desired
                    outcomes.
                  </p>
                </div>
              </Col>
              <Col xs="auto" className="order-xxl-2">
                <div className="x-6">
                  <img src={campaign} alt="" />
                </div>
              </Col>
            </Row>
          </PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <CampaignList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        {/* Greetings */}
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Greetings"
            noPreview
            className="pb-3 pt-3"
          ></PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <BXPGreetingList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        {/* Time Conditions */}
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Time Conditions"
            noPreview
            className="pb-3 pt-3"
          ></PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <BXPTimeConditionList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        {/* Media Resource Groups */}
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Media Resource Groups"
            noPreview
            className="pb-3 pt-3"
          ></PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <BXPMediaResourceGroupList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        {/* Outbound Rules */}
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Outbound Rules"
            noPreview
            className="pb-3 pt-3"
          ></PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <BXPOutboundRuleList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        {/* Calling Lists */}
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Calling Lists"
            noPreview
            className="pb-3 pt-3"
          ></PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <BXPCallingListList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
        {/* Treatments */}
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Treatments"
            noPreview
            className="pb-3 pt-3"
          ></PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <BXPTreatmentList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
      </DocPagesLayout>
    </div>
  );
};

export default CampaignManagement;
